import { render, staticRenderFns } from "./GlobalCheckout.vue?vue&type=template&id=c526ae18&scoped=true"
import script from "./GlobalCheckout.vue?vue&type=script&lang=js"
export * from "./GlobalCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c526ae18",
  null
  
)

export default component.exports